import { Link } from "@/components/link";
import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";
import { buildFeaturePagePath } from "@garimpa/lib/buildFeaturePagePath";
import { type ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function RelatedPagesBlock({
  block,
  locale,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "relatedPages" }>;
  locale: ViewerLocale;
}) {
  const fallbackHeadingId = block.heading ? undefined : `${block.id}-heading`;
  return (
    <FeaturePageSection
      block={block}
      resolvedBackground={block.resolvedBackground}
      labelledById={fallbackHeadingId}
    >
      {block.heading ? (
        <h2
          id={`${block.id}-heading`}
          className="mb-8 text-center text-3xl font-bold tracking-tight sm:text-5xl"
        >
          {block.heading}
        </h2>
      ) : null}
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {block.pages.map((page, index) => {
          const PageHeading = block.heading ? "h3" : "h2";
          return (
            <li key={`${page.family}-${page.slug}`}>
              <Link
                to={buildFeaturePagePath(locale, page.family, page.slug)}
                className="block h-full rounded-2xl border border-border bg-card p-6 transition hover:-translate-y-0.5 hover:border-primary hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
              >
                <PageHeading
                  id={index === 0 ? fallbackHeadingId : undefined}
                  className="text-xl font-bold"
                >
                  {page.label}
                </PageHeading>
                {page.description ? (
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {page.description}
                  </p>
                ) : null}
              </Link>
            </li>
          );
        })}
      </ul>
    </FeaturePageSection>
  );
}
